function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Artboard");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.603922 0 0 0 0 0.603922 0 0 0 0 0.603922 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.603922 0 0 0 0 0.603922 0 0 0 0 0.603922 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.911655 0 0 0 0 0.918425 0 0 0 0 0.922101 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-4"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.911655 0 0 0 0 0.918425 0 0 0 0 0.922101 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(254.000000, 187.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  id: "aquarius"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(449.000000, 490.000000) scale(1, -1) translate(-449.000000, -490.000000) translate(420.000000, 478.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.1899201,24 C51.7319931,24 50.2740661,23.4583936 49.1115761,22.3752954 L46.1191441,19.5870719 C45.5395983,19.0469569 44.6676742,19.0497102 44.0911869,19.5937259 L41.2041063,22.3182782 C38.9013293,24.4914726 35.2936681,24.4915873 32.9908911,22.3182782 L30.1038105,19.5937259 C29.5274365,19.0499397 28.6556256,19.0469569 28.0758533,19.5870719 L25.0834213,22.3751807 C22.7583279,24.5416064 19.2517133,24.5414917 16.92662,22.3751807 L13.9179888,19.5718138 C13.342068,19.0351404 12.4732024,19.0350257 11.8971683,19.5718138 L8.88853719,22.375066 C6.56344383,24.541377 3.05682922,24.5414917 0.731735864,22.375066 C-0.189125715,21.517054 -0.248824823,20.0655808 0.598290798,19.132999 C1.44540642,18.2005319 2.87875142,18.1398435 3.799613,18.9978555 C4.37576038,19.5346436 5.24439939,19.5345289 5.82054677,18.9978555 L8.82917792,16.1946034 C11.154158,14.0282923 14.6608859,14.0282923 16.985866,16.1946034 L19.9946104,18.9979702 C20.5706445,19.5346436 21.4395101,19.5347583 22.0155442,18.9979702 L25.0078629,16.2098615 C26.1250405,15.1689813 27.5726589,14.5963997 29.0859803,14.5963997 L29.1054646,14.5963997 C30.6259228,14.6013328 32.077506,15.1837806 33.1928712,16.2363625 L36.0799518,18.9609148 C36.6599507,19.5082574 37.5349334,19.5082574 38.1149324,18.9609148 L41.002013,16.2363625 C42.1173781,15.1837806 43.5689613,14.6014475 45.0894195,14.5965145 C46.6078385,14.5943347 48.0650858,15.1646219 49.1870213,16.2099762 L52.1794532,18.998085 C52.7554873,19.5347583 53.6243529,19.534873 54.200387,18.998085 C55.1211353,18.140073 56.5544803,18.2006466 57.4017092,19.1332284 C58.2489381,20.0658103 58.1891257,21.5172834 57.2682641,22.3752954 C56.1057741,23.4583936 54.6478471,24 53.1899201,24 L53.1899201,24 Z M57.2682641,7.80538229 C58.1891257,6.94737031 58.2488248,5.49589717 57.4017092,4.56331535 C56.5545936,3.63073353 55.1212486,3.57015988 54.200387,4.42817186 C53.6243529,4.96495995 52.7554873,4.96495995 52.1794532,4.42817186 L49.1870213,1.64006312 C48.0650858,0.594708769 46.6077253,0.0245363438 45.0894195,0.0266013546 C43.5689613,0.031534436 42.1173781,0.613982203 41.002013,1.66644937 L38.1149324,4.39100167 C37.5349334,4.93834425 36.6599507,4.93834425 36.0799518,4.39100167 L33.1928712,1.66644937 C32.077506,0.61386748 30.6259228,0.0314197131 29.1054646,0.0264866318 C29.0990076,0.0264866318 29.0925506,0.0264866318 29.0859803,0.0264866318 C27.5725456,0.0264866318 26.1249272,0.599068236 25.0078629,1.6399484 L22.0155442,4.42805714 C21.4395101,4.96484522 20.5706445,4.96484522 19.9946104,4.42805714 L16.985866,1.62469026 C14.6608859,-0.541620782 11.154158,-0.541506059 8.82917792,1.62469026 L5.82054677,4.42794242 C5.24439939,4.96461578 4.37576038,4.9647305 3.799613,4.42794242 C2.87886471,3.56993043 1.44540642,3.63050408 0.598290798,4.5630859 C-0.248938104,5.495553 -0.189125715,6.94714086 0.731735864,7.80515285 C3.05671594,9.97146389 6.56333055,9.97146389 8.88853719,7.80515285 L11.8971683,5.00190069 C12.4732024,4.46511261 13.342068,4.46511261 13.9179888,5.00190069 L16.9267333,7.80526757 C19.2517133,9.97157862 22.7583279,9.97157862 25.0835346,7.80526757 L28.0759666,5.01715883 C28.6557389,4.47704378 29.5275498,4.48002658 30.1039237,5.02381275 L32.9910043,7.74836505 C35.2938946,9.92167419 38.9015559,9.92155947 41.2042196,7.74836505 L44.0913002,5.02381275 C44.6677874,4.47979713 45.5397116,4.47715851 46.1192574,5.01715883 L49.1116894,7.80538229 C50.2741794,8.88848045 51.7321064,9.43008691 53.1900334,9.43008691 C54.6478471,9.43020162 56.1057741,8.88859518 57.2682641,7.80538229 L57.2682641,7.80538229 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-2)",
  id: "aquarius-copy"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(80.000000, 189.000000) scale(1, -1) translate(-80.000000, -189.000000) translate(51.000000, 177.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.1899201,24 C51.7319931,24 50.2740661,23.4583936 49.1115761,22.3752954 L46.1191441,19.5870719 C45.5395983,19.0469569 44.6676742,19.0497102 44.0911869,19.5937259 L41.2041063,22.3182782 C38.9013293,24.4914726 35.2936681,24.4915873 32.9908911,22.3182782 L30.1038105,19.5937259 C29.5274365,19.0499397 28.6556256,19.0469569 28.0758533,19.5870719 L25.0834213,22.3751807 C22.7583279,24.5416064 19.2517133,24.5414917 16.92662,22.3751807 L13.9179888,19.5718138 C13.342068,19.0351404 12.4732024,19.0350257 11.8971683,19.5718138 L8.88853719,22.375066 C6.56344383,24.541377 3.05682922,24.5414917 0.731735864,22.375066 C-0.189125715,21.517054 -0.248824823,20.0655808 0.598290798,19.132999 C1.44540642,18.2005319 2.87875142,18.1398435 3.799613,18.9978555 C4.37576038,19.5346436 5.24439939,19.5345289 5.82054677,18.9978555 L8.82917792,16.1946034 C11.154158,14.0282923 14.6608859,14.0282923 16.985866,16.1946034 L19.9946104,18.9979702 C20.5706445,19.5346436 21.4395101,19.5347583 22.0155442,18.9979702 L25.0078629,16.2098615 C26.1250405,15.1689813 27.5726589,14.5963997 29.0859803,14.5963997 L29.1054646,14.5963997 C30.6259228,14.6013328 32.077506,15.1837806 33.1928712,16.2363625 L36.0799518,18.9609148 C36.6599507,19.5082574 37.5349334,19.5082574 38.1149324,18.9609148 L41.002013,16.2363625 C42.1173781,15.1837806 43.5689613,14.6014475 45.0894195,14.5965145 C46.6078385,14.5943347 48.0650858,15.1646219 49.1870213,16.2099762 L52.1794532,18.998085 C52.7554873,19.5347583 53.6243529,19.534873 54.200387,18.998085 C55.1211353,18.140073 56.5544803,18.2006466 57.4017092,19.1332284 C58.2489381,20.0658103 58.1891257,21.5172834 57.2682641,22.3752954 C56.1057741,23.4583936 54.6478471,24 53.1899201,24 L53.1899201,24 Z M57.2682641,7.80538229 C58.1891257,6.94737031 58.2488248,5.49589717 57.4017092,4.56331535 C56.5545936,3.63073353 55.1212486,3.57015988 54.200387,4.42817186 C53.6243529,4.96495995 52.7554873,4.96495995 52.1794532,4.42817186 L49.1870213,1.64006312 C48.0650858,0.594708769 46.6077253,0.0245363438 45.0894195,0.0266013546 C43.5689613,0.031534436 42.1173781,0.613982203 41.002013,1.66644937 L38.1149324,4.39100167 C37.5349334,4.93834425 36.6599507,4.93834425 36.0799518,4.39100167 L33.1928712,1.66644937 C32.077506,0.61386748 30.6259228,0.0314197131 29.1054646,0.0264866318 C29.0990076,0.0264866318 29.0925506,0.0264866318 29.0859803,0.0264866318 C27.5725456,0.0264866318 26.1249272,0.599068236 25.0078629,1.6399484 L22.0155442,4.42805714 C21.4395101,4.96484522 20.5706445,4.96484522 19.9946104,4.42805714 L16.985866,1.62469026 C14.6608859,-0.541620782 11.154158,-0.541506059 8.82917792,1.62469026 L5.82054677,4.42794242 C5.24439939,4.96461578 4.37576038,4.9647305 3.799613,4.42794242 C2.87886471,3.56993043 1.44540642,3.63050408 0.598290798,4.5630859 C-0.248938104,5.495553 -0.189125715,6.94714086 0.731735864,7.80515285 C3.05671594,9.97146389 6.56333055,9.97146389 8.88853719,7.80515285 L11.8971683,5.00190069 C12.4732024,4.46511261 13.342068,4.46511261 13.9179888,5.00190069 L16.9267333,7.80526757 C19.2517133,9.97157862 22.7583279,9.97157862 25.0835346,7.80526757 L28.0759666,5.01715883 C28.6557389,4.47704378 29.5275498,4.48002658 30.1039237,5.02381275 L32.9910043,7.74836505 C35.2938946,9.92167419 38.9015559,9.92155947 41.2042196,7.74836505 L44.0913002,5.02381275 C44.6677874,4.47979713 45.5397116,4.47715851 46.1192574,5.01715883 L49.1116894,7.80538229 C50.2741794,8.88848045 51.7321064,9.43008691 53.1900334,9.43008691 C54.6478471,9.43020162 56.1057741,8.88859518 57.2682641,7.80538229 L57.2682641,7.80538229 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-3)",
  id: "sparks"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(204.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M153.21382,239.934304 C150.415974,238.159435 146.709112,238.988067 144.934283,241.785975 C143.159454,244.583884 143.988067,248.290828 146.785914,250.065696 C149.58376,251.840565 153.290622,251.011933 155.065451,248.214025 C156.840881,245.416716 156.011667,241.709172 153.21382,239.934304 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 128,
  cy: 7,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 73,
  cy: 39,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 182,
  cy: 39,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.225989,20.7713823 C252.189742,21.3379069 251.337813,22.1898513 250.770682,23.2267331 L245.999384,31.9508419 L241.228085,23.2267331 C240.660954,22.1898513 239.809641,21.3379069 238.772778,20.7713823 L230.048823,16.0006165 L238.772778,11.2292342 C239.809025,10.6627096 240.660954,9.81014865 241.228085,8.77388333 L245.999384,0.0497745526 L250.770682,8.77388333 C251.337813,9.81014865 252.189126,10.6627096 253.225989,11.2292342 L261.949945,16.0006165 L253.225989,20.7713823 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9068082,126 L6.09319178,126 C2.72855804,126 0,128.686228 0,132 C0,135.313772 2.72794993,138 6.09319178,138 L17.9068082,138 C21.271442,138 24,135.313772 24,132 C24,128.686228 21.271442,126 17.9068082,126 L17.9068082,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9068082,126 L48.0931918,126 C44.728558,126 42,128.686228 42,132 C42,135.313772 44.7279499,138 48.0931918,138 L59.9068082,138 C63.271442,138 66,135.313772 66,132 C66,128.686228 63.271442,126 59.9068082,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,141 C29.6868263,141 27,143.72795 27,147.093192 L27,158.906808 C27,162.27205 29.6862275,165 33,165 C36.3137725,165 39,162.27205 39,158.906808 L39,147.093192 C39,143.72795 36.3131737,141 33,141 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,99 C29.6868263,99 27,101.72795 27,105.093192 L27,116.906808 C27,120.27205 29.6862275,123 33,123 C36.3137725,123 39,120.27205 39,116.906808 L39,105.093192 C39,101.72795 36.3131737,99 33,99 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.906808,126 L195.093192,126 C191.728558,126 189,128.686228 189,132 C189,135.313772 191.72795,138 195.093192,138 L206.906808,138 C210.271442,138 213,135.313772 213,132 C213,128.686228 210.27205,126 206.906808,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.906808,126 L237.093192,126 C233.728558,126 231,128.686228 231,132 C231,135.313772 233.72795,138 237.093192,138 L248.906808,138 C252.271442,138 255,135.313772 255,132 C255,128.686228 252.27205,126 248.906808,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222,141 C218.686826,141 216,143.72795 216,147.093192 L216,158.906808 C216,162.27205 218.686228,165 222,165 C225.313772,165 228,162.27205 228,158.906808 L228,147.093192 C228,143.72795 225.313772,141 222,141 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222,99 C218.686826,99 216,101.72795 216,105.093192 L216,116.906808 C216,120.27205 218.686228,123 222,123 C225.313772,123 228,120.27205 228,116.906808 L228,105.093192 C228,101.72795 225.313772,99 222,99 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-4)",
  id: "sparks-copy"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 340.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M153.21382,239.934304 C150.415974,238.159435 146.709112,238.988067 144.934283,241.785975 C143.159454,244.583884 143.988067,248.290828 146.785914,250.065696 C149.58376,251.840565 153.290622,251.011933 155.065451,248.214025 C156.840881,245.416716 156.011667,241.709172 153.21382,239.934304 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 128,
  cy: 7,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 73,
  cy: 39,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 182,
  cy: 39,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.225989,20.7713823 C252.189742,21.3379069 251.337813,22.1898513 250.770682,23.2267331 L245.999384,31.9508419 L241.228085,23.2267331 C240.660954,22.1898513 239.809641,21.3379069 238.772778,20.7713823 L230.048823,16.0006165 L238.772778,11.2292342 C239.809025,10.6627096 240.660954,9.81014865 241.228085,8.77388333 L245.999384,0.0497745526 L250.770682,8.77388333 C251.337813,9.81014865 252.189126,10.6627096 253.225989,11.2292342 L261.949945,16.0006165 L253.225989,20.7713823 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9068082,126 L6.09319178,126 C2.72855804,126 0,128.686228 0,132 C0,135.313772 2.72794993,138 6.09319178,138 L17.9068082,138 C21.271442,138 24,135.313772 24,132 C24,128.686228 21.271442,126 17.9068082,126 L17.9068082,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9068082,126 L48.0931918,126 C44.728558,126 42,128.686228 42,132 C42,135.313772 44.7279499,138 48.0931918,138 L59.9068082,138 C63.271442,138 66,135.313772 66,132 C66,128.686228 63.271442,126 59.9068082,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,141 C29.6868263,141 27,143.72795 27,147.093192 L27,158.906808 C27,162.27205 29.6862275,165 33,165 C36.3137725,165 39,162.27205 39,158.906808 L39,147.093192 C39,143.72795 36.3131737,141 33,141 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,99 C29.6868263,99 27,101.72795 27,105.093192 L27,116.906808 C27,120.27205 29.6862275,123 33,123 C36.3137725,123 39,120.27205 39,116.906808 L39,105.093192 C39,101.72795 36.3131737,99 33,99 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.906808,126 L195.093192,126 C191.728558,126 189,128.686228 189,132 C189,135.313772 191.72795,138 195.093192,138 L206.906808,138 C210.271442,138 213,135.313772 213,132 C213,128.686228 210.27205,126 206.906808,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.906808,126 L237.093192,126 C233.728558,126 231,128.686228 231,132 C231,135.313772 233.72795,138 237.093192,138 L248.906808,138 C252.271442,138 255,135.313772 255,132 C255,128.686228 252.27205,126 248.906808,126 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222,141 C218.686826,141 216,143.72795 216,147.093192 L216,158.906808 C216,162.27205 218.686228,165 222,165 C225.313772,165 228,162.27205 228,158.906808 L228,147.093192 C228,143.72795 225.313772,141 222,141 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222,99 C218.686826,99 216,101.72795 216,105.093192 L216,116.906808 C216,120.27205 218.686228,123 222,123 C225.313772,123 228,120.27205 228,116.906808 L228,105.093192 C228,101.72795 225.313772,99 222,99 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  stroke: "#C0C0C0",
  strokeWidth: 5,
  fill: "#FFFFFF",
  x: 218.5,
  y: 209.5,
  width: 225,
  height: 324,
  rx: 16
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#DBDBDB",
  x: 89,
  y: 111,
  width: 269,
  height: 391,
  rx: 24
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#666666",
  strokeWidth: 5,
  fill: "#FFFFFF",
  x: 114.5,
  y: 92.5,
  width: 264,
  height: 386,
  rx: 24
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  x: 133,
  y: 151,
  width: 228,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  fill: "#D8D8D8",
  x: 133,
  y: 151,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fill: "#D8D8D8",
  x: 133,
  y: 203,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  fill: "#D8D8D8",
  x: 133,
  y: 177,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 309.5,
  y1: 320.5,
  x2: 335.5,
  y2: 346.5,
  id: "Line",
  stroke: "#666666",
  strokeWidth: 4,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  fill: "#D8D8D8",
  x: 133,
  y: 229,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-13",
  fill: "#D8D8D8",
  x: 133,
  y: 255,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#666666",
  strokeWidth: 4,
  fill: "#FFFFFF",
  transform: "translate(371.500000, 380.000000) rotate(43.000000) translate(-371.500000, -380.000000) ",
  x: 318,
  y: 370,
  width: 107,
  height: 20,
  rx: 10
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-12",
  fill: "#D8D8D8",
  x: 133,
  y: 307,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-11",
  fill: "#D8D8D8",
  x: 133,
  y: 281,
  width: 209,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  fill: "#D8D8D8",
  x: 133,
  y: 430,
  width: 108,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-14",
  fill: "#D8D8D8",
  x: 133,
  y: 365,
  width: 108,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-15",
  fill: "#D8D8D8",
  x: 133,
  y: 333,
  width: 108,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-10",
  fill: "#D8D8D8",
  x: 133,
  y: 388,
  width: 182,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#666666",
  strokeWidth: 4,
  fill: "#FFFFFF",
  cx: 247.5,
  cy: 261.5,
  r: 97.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.591905,234.817054 C200.957357,240.967215 205.801916,242.545918 216.163817,234.224387",
  id: "Path-2",
  stroke: "#666666",
  strokeWidth: 5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.687977,236.913513 C262.388236,242.394694 265.829013,246.637032 273.951471,235.08609",
  id: "Path-3",
  stroke: "#666666",
  strokeWidth: 5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.128057,289.309673 C215.854296,274.651512 245.365035,272.389621 262.107043,292.723632",
  id: "Path-4",
  stroke: "#666666",
  strokeWidth: 5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-8",
  fill: "#D8D8D8",
  x: 247,
  y: 430,
  width: 108,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-9",
  fill: "#D8D8D8",
  x: 133,
  y: 409,
  width: 222,
  height: 13,
  rx: 6.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.510122,230.106879 C324.195686,213.791602 313.201336,199.842229 298.714285,189.767844 C283.882582,179.4525 266.460869,174 248.332988,174 C244.283712,174 241,177.259852 241,181.279706 C241,185.29956 244.283712,188.559412 248.332988,188.559412 C278.470837,188.559412 305.993009,207.354158 316.820166,235.329341 C317.940647,238.223752 320.719116,240 323.666977,240 C324.541069,240 325.430561,239.843486 326.29512,239.513716 C330.075276,238.071606 331.962787,233.860296 330.510122,230.106879 Z",
  id: "Path",
  fill: "#EFEFEF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#EFEFEF",
  cx: 169,
  cy: 283,
  r: 11
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#EFEFEF",
  cx: 290,
  cy: 287,
  r: 11
})), /*#__PURE__*/React.createElement("text", {
  id: "No-Results-to-show",
  fill: "#666666",
  fillRule: "nonzero",
  fontFamily: "Helvetica-Oblique, Helvetica",
  fontSize: 48,
  fontStyle: "italic",
  fontWeight: "normal"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 32,
  y: 672
}, "No Results to show"))));

var SvgEmptySearchIcon = function SvgEmptySearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 987 1097",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptySearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptySearchIcon.65a8152f.svg";
export { ForwardRef as ReactComponent };